<template>
  <modals-request
    id="UploadClientFileImage"
    v-model="payload"
    :btn-attrs="btnAttrs"
    :request-class="proxyRequest"
    :disabled-send="disabled"
    :config-swal="config"
    label="Enviar imagem"
    title="Fazer upload de imagem para um cliente?"
    persistent
    @success="success($event)"
  >
    <form-group>
      <v-row
        v-for="(item, key) in payload"
        :key="`image_upload_${key}`"
        class="pt-3"
      >
        <v-col :cols="getCols()">
          <v-row>
            <v-col cols="6">
              <input-select
                id="input:documentType"
                v-model="item.documentType"
                :items="fileCategories"
                :rules="[requiredRule]"
                label="Tipo da imagem"
                required
              />'
            </v-col>
            <v-col cols="6">
              <input-upload
                id="input:file"
                v-model="item.file"
                label="Documento"
                :rules="[requiredRule]"
                required
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col :cols="getCols(2, 1)">
          <remove-add-buttons
            v-model="payload"
            :position="key"
            @add="addFile()"
            @remove="removeFile(key)"
          />
        </v-col>
      </v-row>
    </form-group>
  </modals-request>
</template>

<script>
import ModalsRequest from '@/app/arch/components/modals/ModalsRequest.vue';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import AnalysisTableRequest from 'Modules/contacard/analysisTable/AnalysisTableRequest';
import DocumentsType from 'Arch/enums/DocumentsType';
import RemoveAddButtons from '@/app/arch/components/Buttons/RemoveAddButtons.vue';
import UploadService from '@/app/arch/services/UploadService';

const faultFile = {
  documentType: '',
  file: {
    name: '',
    file: '',
    rawFile: null,
  },
};

export default {
  name: 'UploadClientFileImage',
  components: { ModalsRequest, FormGroup, RemoveAddButtons },
  mixins: [ServiceMixin, RulesMixin],
  data: () => ({
    payload: [
      {
        ...faultFile,
        file: {
          ...faultFile.file,
        },
      },
    ],
    fileCategories: DocumentsType.filter(
      (item) => item.value !== 'SelfieToConfirmUser',
    ),
    requestClass: AnalysisTableRequest,
    requestUpload: UploadService,
    config: {
      successMessage: 'Sucesso ao fazer upload de imagem para cliente!',
      errorMessage: 'Falha ao fazer upload de imagem para cliente!',
    },
  }),
  computed: {
    btnAttrs() {
      return {
        color: 'primary',
        outlined: true,
        ...this.$attrs,
      };
    },
    disabled() {
      return this.payload.map(
        ({ documentType, file }) => !documentType || !(file && file.rawFile),
      ).find(
        (item) => item,
      );
    },
    clientId() {
      return this.analysisTable.client.id;
    },
    userSystemId() {
      return this.analysisTable.client.idUsuarioAdmin;
    },
    proxyRequest() {
      return () => this.uploadFiles();
    },
    getCols() {
      return (minCol = 10, maxCol = 11) => {
        if (this.payload.length > 1) {
          return minCol;
        }
        return maxCol;
      };
    },
    getIds() {
      return {
        ClientId: this.clientId,
        UserSystemId: this.userSystemId,
      };
    },
  },
  methods: {
    success(ev) {
      this.$emit('success', ev);
    },
    addFile() {
      this.payload.push({
        ...faultFile,
        file: {
          ...faultFile.file,
        },
      });
    },
    removeFile(pos) {
      this.payload.splice(pos, 1);
    },
    uploadFiles() {
      return Promise.all(
        this.makePromisesToUpload(),
      ).then(
        this.prepareFileToSave,
      );
    },
    makePromisesToUpload() {
      const promises = [];
      this.payload.forEach(
        ({ file }) => {
          promises.push(
            this.requestUpload.create(file),
          );
        },
      );
      return promises;
    },
    async prepareFileToSave(responses = []) {
      return this.requestClass.uploadUserDocument(
        this.getIds,
        this.prepareFilesResponse(
          responses.map(
            (response) => response.data,
          ),
        ),
      );
    },
    prepareFilesResponse(files = []) {
      return {
        documents: this.payload.map(
          ({ documentType }, pos) => ({
            documentType,
            fileName: files[pos].fileName,
          }),
        ),
      };
    },
  },
  inject: {
    analysisTable: {
      default() {
        return {
          client: {
            id: '',
            idUsuarioAdmin: '',
          },
        };
      },
    },
  },
};
</script>

<style scoped>
#UploadClientFileImage {
  min-width: 700px;
  width: max-content;
}
</style>
